<template>
  <div
    :id="archiveDomID"
    class="archiveListItem"
    data-automation="package-archived-versions-list"
    :class="{ active : isSelected }"
    @click="handleClick"
  >
    <div data-automation="package-archived-version">
      {{ archiveItem.version }}
    </div>
    <div
      class="date"
      data-automation="package-archived-date"
    >
      {{ archiveDate }}
    </div>
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import * as types from '../store/mutation-types'
import { packageUtils } from '../utils/package-utils'

export default {
  name: 'ArchiveListItem',
  props: {
    archiveItem: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      selected: false,
    }
  },
  computed: {
    ...mapState({
      currentRepoId: state => state.repos.currentRepoId,
      selectedPackage: state => state.packages.selectedPackage,
      selectedArchive: state => state.packages.selectedArchive,
    }),
    ...mapGetters([
      'getDocument',
    ]),
    isSelected: function () {
      if (this.selectedArchive) {
        return this.selectedArchive.id === this.archiveItem.id
      } else {
        return false
      }
    },
    archiveDomID: function () {
      return `e2e-archive-${this.archiveItem.id}`
    },
    archiveDate: function () {
      return packageUtils.getPackageDate(this.archiveItem)
    },
  },
  methods: {
    handleClick: function (event) {
      this.$store.commit(types.SET_SELECTED_ARCHIVE, this.archiveItem)
    },
  },
}

</script>
